module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "sign-up-illustration@2x.71e87c23.png" + "?" + Date.now();